import React, { Component } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import Scrollbar from "react-scrollbars-custom";
import {
  DatePicker,
  Select,
  Skeleton,
  Segmented,
  // Popover,
  Button,
  Spin,
} from "antd";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import * as XLSXSH from "sheetjs-style";
import * as FileSaver from "file-saver";
import {
  EyeInvisibleOutlined,
  // MoreOutlined,
  // PlaySquareOutlined,
  ReloadOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { getUser } from "../../../utils/helpers";
import {
  postBatchReports,
  updateStatusBatchReports,
  getBatchReports,
  getBatchReportsOverDue,
  getBatchReportsReady,
  getBatchReportsFilter,
  deleteWoSampleTest,
  getSearchOptions,
  editWoCustomer,
  generateParitailTestReports,
  getBatchReportDetail,
  getExportBatchReportsOverDueInfoList,
  getExportBatchReportsReadyInfoList,
} from "../../../actions/batchReports";
import {
  updateTestResult,
  checkReadyReports,
  runQCApiPost,
} from "../../../actions/sendReports";
import ConfirmationModal from "../../Common/ConfirmationModal";
import BatchReportsSearch from "./BatchReportsSearch";
import { ToolTip } from "../ToolTips/ToolTip";
import Loading from "../../../assets/images/loading.gif";
import BatchReportsAlert from "./BatchReportsAlert";
import BatchReportsPreviewTable from "./BatchReportsPreviewTable";
import BlockedResultsModal from "../../Common/BlockedResultsModal";
import { BATCH_REPORT_GENERATE_STATUS, BATCH_REPORT_WO_STATUS } from "../../../utils/statusConfig";
import {
  getActiveBatchReportFilterKeys,
  getBatchReportFilterFieldClassName,
  getBatchReportsModeButtonClassName,
} from "./batchReportActiveFilters";
import "./batchreports.css";

const batchReportsBlockedColumns = [
  { title: "Workorder ID", dataIndex: "WorkorderID", key: "WorkorderID" },
  { title: "Reason", dataIndex: "Reason", key: "Reason" },
];

export default class BatchReports extends Component {
  constructor(props) {
    super(props);
    const { authorizedViewOptions } = this.props;
    this.state = {
      selectedDate: new Date(new Date().setDate(new Date().getDate() - 1)),
      workOrderList: [],
      originalWorkOrderList: [],
      noResults: [],
      selectedOption: "All",
      reportDate: "",
      receivedDate: "",
      resultsDueDate: "",
      selectedUpdateStatus: "Pending",
      dueByResults: false,
      readyResults: false,
      overDueResults: false,
      loading: false,
      postApiLoading: false,
      confirmBatchReports: false,
      previewTableData: {},
      previewTableKey: 0,
      searchParameter: null,
      search: "",
      statusOptions: [
        { value: "pending", label: "Pending", color: "#19305a" },
        { value: "pending-sp", label: "Pending - Special", color: "#0ac192" },
        { value: "complete", label: "Complete", color: "#ea33f7" },
        { value: "All", label: "All", color: "#19305a" },
      ],
      pendingStatusOptions: [
        { value: "Pending", label: "Pending", color: "#19305a" },
        { value: "Complete", label: "Complete", color: "#ea33f7" },
      ],
      customerListWithID: [],
      customerListWithoutID: [],
      apiController: null,
      view: authorizedViewOptions.length > 0 ? authorizedViewOptions[0].value : "ExcludeShelfLifeThirdParty",
      user: getUser(),
      loadingPreviewWoId: null,
      showBlockedModal: false,
      blockedResults: [],
    };
    this.cmptMounted = true;
  }

  componentDidMount() {
    const { selectedDate } = this.state;
    this.apiBatchReports(selectedDate, false);
    this.fetchCustomerList();
  }

  componentWillUnmount() {
    this.cmptMounted = false;
  }

  // eslint-disable-next-line react/sort-comp
  filterWorkOrderList = (customerName, list = null) => {
    const { originalWorkOrderList } = this.state;
    if (customerName === null) return originalWorkOrderList;

    const listToLoop = list === null ? originalWorkOrderList : list;
    return listToLoop.filter((workOrder) => {
      if (workOrder.customer_name === customerName) {
        return workOrder;
      }

      return null;
    });
  }

  updateSearchParameter = (searchObj) => {
    const company = searchObj ? searchObj.company : null;
    const filteredWorkOrderList = this.filterWorkOrderList(company);

    this.handleClearAll();
    this.setState({
      searchParameter: searchObj,
      workOrderList: filteredWorkOrderList,
      previewTableData: {},
    });
  }

  handleSearch = (search) => {
    const { view } = this.state;
    this.setState({ search, previewTableData: {} }, () => {
      this.handleWoTypeOnChange(view);
    });
  }

  /**
  * Use the AbortController to cancel the last producttemplates/ call if the last call was still in progress.
  * @param {*} controller
  */
  abortPrevApiCall = (controller) => {
    const { apiController } = this.state;
    if (apiController) {
      apiController.abort();
    }
    this.setState({ apiController: controller });
  };

  apiBatchReports = async (date, dueBy) => {
    const { searchParameter, view, search } = this.state;
    try {
      this.setState({
        loading: true,
        previewTableData: {},
        workOrderList: [],
        originalWorkOrderList: [],
        readyResults: false,
        overDueResults: false,
        dueByResults: !!dueBy,
        resultsDueDate: dueBy ? date : "",
        reportDate: "",
        receivedDate: "",
        selectedDate: dueBy ? "" : date,
        selectedOption: "All",
      }, async () => {
        const controller = new AbortController();
        this.abortPrevApiCall(controller);
        const category = dueBy ? "dueby" : "";
        const response = await getBatchReports(
          moment(date).format("MM/DD/YYYY"),
          category,
          view,
          controller.signal,
          search,
        );
        if (!this.cmptMounted) return;
        if (response && response.success) {
          this.setState({
            workOrderList: searchParameter === null ? response.list : this.filterWorkOrderList(searchParameter.company, response.list),
            originalWorkOrderList: response.list,
          });
          this.loading(false);
        } else if (!response.canceled) {
          toast.error(response.message);
          this.loading(false);
        }
      });
    } catch (e) {
      console.log("Something went wrong", e);
      this.loading(false);
    }
  };

  getWoPreviewData = (workOrderList, workorder_id) => {
    let previewTableData = {};
    if (workorder_id === "skip") {
      return previewTableData;
    }
    workOrderList.every(
      (obj) => {
        if (obj.wo_id === workorder_id) {
          previewTableData = obj;
          return false;
        }
        return true;
      },
    );
    return previewTableData;
  }

  filterBatchReports = async (
    filter,
    date,
    checkReadyResults,
    checkOverDueResults,
    checkDueByResults,
    checkDueByResultsDate,
  ) => {
    const { searchParameter, view, search } = this.state;

    try {
      this.setState({ loading: true, previewTableData: {}, workOrderList: [] });
      const controller = new AbortController();
      this.abortPrevApiCall(controller);
      const response = await getBatchReportsFilter(
        filter,
        date,
        checkReadyResults,
        checkOverDueResults,
        checkDueByResults,
        moment(checkDueByResultsDate).format("MM/DD/YYYY"),
        view,
        controller.signal,
        search,
      );
      if (response && response.success) {
        const workOrderList = searchParameter === null ? response.list : this.filterWorkOrderList(searchParameter.company, response.list);
        this.setState({
          workOrderList,
          originalWorkOrderList: response.list,
          postApiLoading: false,
        });
        this.loading(false);
        return true;
      }
      if (response.canceled) {
        return true;
      }
      toast.error(response.message);
      this.loading(false);
      this.setState({ postApiLoading: false });
      return false;
    } catch (e) {
      console.log("Something went wrong", e);
      this.setState({ postApiLoading: false });
      this.loading(false);
      return false;
    }
  };

  handleOverDueResults = async () => {
    const { searchParameter, view, search } = this.state;
    try {
      this.setState({
        loading: true,
        previewTableData: {},
        workOrderList: [],
        originalWorkOrderList: [],
        overDueResults: true,
        readyResults: false,
        dueByResults: false,
        selectedDate: "",
        resultsDueDate: "",
        reportDate: "",
        receivedDate: "",
        selectedOption: "All",
      }, async () => {
        const controller = new AbortController();
        this.abortPrevApiCall(controller);
        const response = await getBatchReportsOverDue(view, controller.signal, search);
        if (response && response.success) {
          this.setState({
            workOrderList: searchParameter === null ? response.list : this.filterWorkOrderList(searchParameter.company, response.list),
            originalWorkOrderList: response.list,
            loading: false,
            loadingPreviewWoId: null,
          });
        } else if (!response.canceled) {
          toast.error(response.message);
          this.loading(false);
        }
      });
    } catch (e) {
      this.loading(false);
      console.log("Something went wrong", e);
    }
  };

  /**
   * Make an api call to get the current overdue results and export it in an excel format
   */
  exportOverDueResults = async () => {
    const { searchParameter, view } = this.state;
    try {
      this.setState({ postApiLoading: true });
      const response = await getExportBatchReportsOverDueInfoList(view);
      if (response && response.success) {
        const workOrderList = searchParameter === null ? response.list : this.filterWorkOrderList(searchParameter.company, response.list);
        this.exportCsvData(workOrderList);
      } else {
        toast.error(response.message);
      }
      this.setState({ postApiLoading: false });
    } catch (e) {
      this.setState({ postApiLoading: false });
      console.log("Something went wrong - exportOverDueResults()", e);
      toast.error("Something went wrong");
    }
  }

  exportReadyResults = async () => {
    const { searchParameter, view } = this.state;
    try {
      this.setState({ postApiLoading: true });
      const response = await getExportBatchReportsReadyInfoList(view);
      if (response && response.success) {
        const workOrderList = searchParameter === null ? response.list : this.filterWorkOrderList(searchParameter.company, response.list);
        this.exportCsvData(workOrderList, {
          emptyMessage: "No Ready Results",
          fileNamePrefix: "Ready_Results_",
          extraColumns: [{ label: "Result", key: "result", afterKey: "test_status" }],
        });
      } else {
        toast.error(response.message);
      }
      this.setState({ postApiLoading: false });
    } catch (e) {
      this.setState({ postApiLoading: false });
      console.log("Something went wrong - exportReadyResults()", e);
      toast.error("Something went wrong");
    }
  }

  /**
   * Export overdue work orders and tests to Excel. Row order follows the API / backend (no client-side sort).
   * @param {*} data overdue results
   * @returns
   */
  exportCsvData = (data, exportConfig = {}) => {
    const {
      emptyMessage = "No Overdue Results",
      fileNamePrefix = "Overdue_Results_",
      extraColumns = [],
    } = exportConfig;
    if (data.length === 0) {
      toast.warn(emptyMessage);
      return;
    }
    const { searchParameter } = this.state;
    const csvData = this.processOverdueCsvData(data, extraColumns);
    const head = csvData[0];
    const ws = XLSX.utils.json_to_sheet(csvData);
    let colCount = 0;
    // make the header row bold
    for (let i in head) { // eslint-disable-line
      const col = `${XLSX.utils.encode_col(colCount)}1`;
      ws[col].s = { font: { bold: true } };
      colCount++;
    }
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSXSH.write(wb, {
      bookType: "xlsx",
      type: "array",
      cellStyles: "true",
    });
    const fileName = `${fileNamePrefix}${searchParameter === null ? "" : (`${searchParameter.company}_`)}${moment(new Date()).format("MM/DD/YYYY_h:mm:ss_a")}`;
    const file = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    FileSaver.saveAs(file, fileName);
  }

  /**
   * Build export rows from /getwosbatchreportsexport/ flat list (backend order; no client sort).
   * Inserts a blank separator row when Genista ID changes from the previous data row.
   * @param {*} data
   * @returns
   */
  processOverdueCsvData = (data, extraColumns = []) => {
    const csvData = [];
    let previousGenistaId = null;
    const excelColumns = [
      { label: "Customer", key: "customer_name" },
      { label: "Customer ID", key: "customer_id" },
      { label: "WO#", key: "wo_id" },
      { label: "WO Created At", key: "wo_created_at" },
      { label: "WO Created By", key: "wo_created_by" },
      { label: "GenistaID", key: "genista_id" },
      { label: "Test", key: "internal_name" },
      { label: "Test Category", key: "test_category" },
      { label: "Chemistry Stage", key: "chemistry_stage" },
      { label: "Result Status", key: "test_status" },
      { label: "Report Status", key: "generate_status", renderValueFn: (value) => BATCH_REPORT_GENERATE_STATUS[value]?.label ?? "" },
      { label: "Received Date", key: "received_date" },
      { label: "TAT", key: "turn_around_time" },
      { label: "Due Date", key: "due_by" },
      { label: "Prepped Date", key: "sample_prep_date" },
      { label: "Days taken to process by Lab", key: "days_taken_to_process_by_lab", renderValueFn: (value) => String(value) },
      { label: "Days taken by QC Analyst Team", key: "days_taken_by_qc_analyst_team", renderValueFn: (value) => String(value) },
      { label: "Assigned To (QC Analyst)", key: "manual_qc_assigned_to_name" },
      { label: "Days Overdue", key: "overdue_by", renderValueFn: (value) => (value === 0 ? "Due Today" : String(value)) },
      { label: "Business Days Overdue", key: "business_days_overdue", renderValueFn: (value) => String(value) },
      { label: "Method Reference", key: "method" },
      { label: "Delay ETA", key: "expected_eta" },
      { label: "Delay Reported By", key: "reports_delay_created_by_name" },
      { label: "Delay Reported At", key: "reports_delay_created_at" },
      { label: "Delay Reason", key: "reports_delay_reason" },
      { label: "Delay Comment", key: "reports_delay_comments" },
      { label: "Sample Issue", key: "sample_issue" },
      { label: "Site Group", key: "site_group" },
      { label: "Resolved By", key: "resolved_by" },
      { label: "Action Taken", key: "action_taken" },
    ];
    extraColumns.forEach((column) => {
      const anchorIndex = excelColumns.findIndex((item) => item.key === column.afterKey);
      const insertAt = anchorIndex === -1 ? excelColumns.length : anchorIndex + 1;
      excelColumns.splice(insertAt, 0, { label: column.label, key: column.key });
    });
    data.forEach((row) => {
      // Add a blank row between each GenistaID
      if (previousGenistaId !== null && row.genista_id !== previousGenistaId) {
        csvData.push(excelColumns.reduce((acc, item) => {
          const { label } = item;
          acc[label] = "";
          return acc;
        }, {}));
      }

      // Add the row data
      csvData.push(excelColumns.reduce((acc, item) => {
        const { label, key, renderValueFn } = item;
        let value = "";
        if (key && row[key] !== null && row[key] !== undefined) {
          value = renderValueFn ? renderValueFn(row[key]) : row[key];
        }
        acc[label] = value;
        return acc;
      }, {}));
      previousGenistaId = row.genista_id;
    });

    return csvData;
  }

  handleReadyResults = async () => {
    const { searchParameter, view, search } = this.state;

    try {
      this.setState({
        loading: true,
        previewTableData: {},
        workOrderList: [],
        originalWorkOrderList: [],
        readyResults: true,
        overDueResults: false,
        dueByResults: false,
        selectedDate: "",
        resultsDueDate: "",
        reportDate: "",
        receivedDate: "",
        selectedOption: "All",
      }, async () => {
        const controller = new AbortController();
        this.abortPrevApiCall(controller);
        const response = await getBatchReportsReady(view, controller.signal, search);
        if (response && response.success) {
          this.setState({
            workOrderList: searchParameter === null ? response.list : this.filterWorkOrderList(searchParameter.company, response.list),
            originalWorkOrderList: response.list,
            loading: false,
            loadingPreviewWoId: null,
          });
        } else if (!response.canceled) {
          this.loading(false);
          toast.error(response.message);
        }
      });
    } catch (e) {
      this.loading(false);
      console.log("Something went wrong - handleReadyResults", e);
    }
  };

  handleSelectAll = () => {
    const { workOrderList } = this.state;
    const list = workOrderList;
    list.forEach((report) => {
      report.checked = true;
    });
    this.setState({ workOrderList: list });
  };

  handleClearAll = () => {
    const { workOrderList } = this.state;
    const list = workOrderList;
    list.forEach((report) => {
      report.checked = false;
    });
    this.setState({ workOrderList: list });
  };

  handleChangeCheckbox = (e, woID) => {
    const { workOrderList } = this.state;
    const list = workOrderList;
    list.forEach((report) => {
      if (report.wo_id === woID) {
        report.checked = !report.checked;
      }
    });
    this.setState({ workOrderList: list });
  };

  handleDate = (e) => {
    let date;
    if (!e || !e.$d) {
      date = new Date(new Date().setDate(new Date().getDate() - 1));
    } else {
      date = e.$d;
    }
    const dueDate = false;
    this.apiBatchReports(date, dueDate);
  };

  handleResultsDueDate = (e) => {
    let date;
    if (!e || !e.$d) {
      date = new Date();
    } else {
      date = e.$d;
    }
    const dueDate = true;
    this.apiBatchReports(date, dueDate);
  };

  handleReportDate = (e) => {
    let date;
    if (!e || !e.$d) {
      date = "";
    } else {
      date = moment(e.$d).format("MM/DD/YYYY");
    }
    this.setState({
      reportDate: date,
    });
  };

  handleReceivedDate = (e) => {
    let date;
    if (!e || !e.$d) {
      date = "";
    } else {
      date = moment(e.$d).format("MM/DD/YYYY");
    }
    this.setState({
      receivedDate: date,
    });
  };

  handleCancelConfirm = () => {
    this.setState({
      confirmBatchReports: false,
    });
  }

  handleSubmitConfirm = () => {
    const { workOrderList, confirmBatchReports } = this.state;
    const list = workOrderList;
    const payload = [];
    list.forEach((report) => {
      if (report.checked === true) {
        payload.push({ wo_id: report.wo_id });
      }
    });
    if (payload.length < 1) {
      toast.warn("Please select a work order!");
      return;
    }
    this.setState({ confirmBatchReports: !confirmBatchReports });
  }

  handleSubmit = async (e, generatePartial, partialResults) => {
    const {
      workOrderList, reportDate, receivedDate, noResults, user,
    } = this.state;

    const frontend_log_data = { action: "Generate Report" };
    if (generatePartial) {
      frontend_log_data.action = "Generate Paritial";
    } else if (partialResults) {
      frontend_log_data.action = "Partial Results";
    }
    const list = workOrderList;
    const payload = [];
    const date = moment(new Date()).format("MM/DD/YYYY");
    list.forEach((report) => {
      if (report.checked === true) {
        if (generatePartial) {
          payload.push({ wo_id: report.wo_id, is_partial: "True" });
        } else if (partialResults) {
          console.log("partialResults:", partialResults);
        } else {
          payload.push({ wo_id: report.wo_id, is_partial: "False" });
        }
      }
    });

    if (!partialResults) {
      if (payload.length < 1) {
        toast.warning("Please select a work order!");
        return;
      }
    }
    this.setState({ confirmBatchReports: false });
    if (partialResults) {
      try {
        this.setState({ postApiLoading: true });
        const response = await postBatchReports(
          payload,
          date,
          reportDate,
          receivedDate,
          generatePartial,
          partialResults,
          user.id,
          frontend_log_data,
        );
        if (response && response.success) {
          const files = response.result;
          this.setState({ reportDate: "", receivedDate: "" });
          let downloaded = false;
          files.forEach((file) => {
            if (file.Message && file.Message.length > 0) {
              noResults.push(file.Message);
            }
          });
          downloaded = true;
          if (downloaded) {
            this.setState({ postApiLoading: false });
          }
        } else {
          this.setState({ postApiLoading: false });
          toast.error(response.message);
        }
      } catch (event) {
        this.setState({ postApiLoading: false });
        console.log("Something went wrong - handleSubmit()", event);
      }
    } else if (payload.length < 1) {
      toast.error("Please Select at least one WO#");
    } else {
      try {
        this.setState({ postApiLoading: true });
        const response = await postBatchReports(
          payload,
          date,
          reportDate,
          receivedDate,
          generatePartial,
          partialResults,
          user.id,
          frontend_log_data,
        );
        if (response && response.success) {
          this.setState({ reportDate: "", receivedDate: "" });
          const files = response.result;
          let downloaded = false;
          files.forEach((file) => {
            if (file.Message && file.Message.length > 0) {
              noResults.push(file.Message);
            }
          });
          downloaded = true;
          if (downloaded) {
            this.setState({ postApiLoading: false });
          }
        } else {
          this.setState({ postApiLoading: false });
          toast.error(response.message);
        }
      } catch (event) {
        this.setState({ postApiLoading: false });
      }
    }
  };

  /**
   * Make an api call to generate a report for the partial tests
   * @param {*} wo_id
   * @param {*} partial_selected_dict
   * @returns
   */
  handlePartialTestSubmit = async (wo_id, partial_selected_dict) => {
    this.setState({ postApiLoading: true });
    const {
      reportDate, receivedDate, noResults, user,
    } = this.state;
    const date = moment(new Date()).format("MM/DD/YYYY");
    const payload = {
      list: [{ wo_id, is_partial: "True", partial_selected_dict }],
      is_partial: "False",
      date: reportDate === "Invalid date" || reportDate === "" ? date : reportDate,
      received_date: receivedDate === "Invalid date" ? "" : receivedDate,
      user_id: user.id,
      frontend_log_data: { action: "Generate Partial Tests" },
    };

    const response = await generateParitailTestReports(payload);

    /** Failure case */
    if (!response.success) {
      const message = response.message ?? "Something went wrong";
      toast.error(message);
      this.setState({ postApiLoading: false });
      return false;
    }

    /** Success case */
    this.setState({ reportDate: "", receivedDate: "", postApiLoading: false });
    const files = response.result;
    files.forEach((file) => {
      if (file.Message.length > 0) {
        noResults.push(file.Message);
      }
    });
    this.setState({ postApiLoading: false });
    return true;
  }

  handleChangeSelect(
    statusValue,
    readyResults,
    overDueResults,
    dueByResults,
    dueByResultsDate,
  ) {
    const { selectedDate } = this.state;
    const date = moment(selectedDate).format("MM/DD/YYYY");
    const checkDueByResultsDate = moment(dueByResultsDate).format("MM/DD/YYYY");
    const checkReadyResults = readyResults;
    const checkOverDueResults = overDueResults;
    const checkDueByResults = dueByResults;
    const filter = statusValue;
    this.setState({ selectedOption: filter, workOrderList: [], previewTableData: {} }, () => this.filterBatchReports(
      filter,
      date,
      checkReadyResults,
      checkOverDueResults,
      checkDueByResults,
      checkDueByResultsDate,
    ));
  }

  loading(value) {
    this.setState({ loading: value });
    if (!value) {
      this.setState({ loadingPreviewWoId: null });
    }
  }

  onToggleModal = () => {
    this.setState({
      noResults: [],
    });
  };

  handleUpdateStatus(value) {
    this.setState({
      selectedUpdateStatus: value,
    });
  }

  fetchCustomerList = async () => {
    const response = await getSearchOptions();
    const customerListWithID = [];
    const customerListWithoutID = [];
    if (!this.cmptMounted) return;
    if (response && response.success) {
      response.list.forEach(
        (item) => {
          customerListWithID.push({
            value: `${item.company} (${item.customer_id})`,
            option: item,
          });
          customerListWithoutID.push({
            value: item.customer_id,
            label: `${item.company}`,
            option: item,
            disabled: !!item.billing_mode,
          });
        },
      );
      this.setState({ customerListWithID, customerListWithoutID });
    } else {
      toast.info(response.message);
    }
  }

  handleUpdateStatusSubmit = async () => {
    this.loading(true);
    const {
      workOrderList, selectedUpdateStatus, selectedDate, resultsDueDate,
    } = this.state;
    const list = workOrderList;
    const status = selectedUpdateStatus;
    let dueDate = false;
    let date = selectedDate;
    if (date === "") {
      date = resultsDueDate;
      dueDate = true;
    }

    const payload = [];

    list.forEach((report) => {
      if (report.checked === true) {
        payload.push(report.wo_id);
      }
    });

    if (payload.length > 0) {
      this.setState({ previewTableData: {}, workOrderList: [] }, async () => {
        const response = await updateStatusBatchReports(status, payload);
        if (response && response.success) {
          this.apiBatchReports(date, dueDate);
        } else if (response && response.status207) {
          this.setState({
            blockedResults: response.result,
            showBlockedModal: true,
          });
          this.apiBatchReports(date, dueDate);
        } else {
          this.loading(false);
          toast.error(response.message.trim());
          this.apiBatchReports(date, dueDate);
        }
      });
    } else {
      this.loading(false);
      toast.warning("Please Select at least one WO#");
    }
  };

  toggleBlockedModal = () => {
    this.setState((prev) => ({
      showBlockedModal: !prev.showBlockedModal,
      blockedResults: prev.showBlockedModal ? [] : prev.blockedResults,
    }));
  };

  handleWorkorderSelect = async (report) => {
    const {
      previewTableKey, previewTableData, dueByResults, overDueResults,
    } = this.state;
    const newKey = previewTableKey + 1;
    const controller = new AbortController();
    this.abortPrevApiCall(controller);
    this.setState({ loadingPreviewWoId: report.wo_id });
    let scroll = false;
    const {
      success, info_list, message, canceled, customer_name, wo_esv_data,
    } = await getBatchReportDetail({ wo_id_pk: report.wo_id_pk }, controller.signal);
    if (canceled) return;

    if (Object.keys(previewTableData).length === 0) {
      scroll = true;
    }
    const showOverdueIconAndTooltip = overDueResults || dueByResults;
    if (success) {
      this.setState({
        previewTableData: {
          ...report, info_list, customer_name, showOverdueIconAndTooltip, wo_esv_data,
        },
        previewTableKey: newKey,
        loadingPreviewWoId: null,
      }, () => {
        const element = document.getElementById(report.wo_id);
        if (scroll) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });
    } else {
      toast.error(message);
      this.setState({ loadingPreviewWoId: null });
    }
  }

  handleClosePreview = () => {
    this.setState({ previewTableData: {} });
  }

  /**
   * Make an api call to get the latest workorder detail
   */
  setLatestWoDetail = async () => {
    const {
      previewTableKey,
      previewTableData,
    } = this.state;
    const {
      success, info_list, message, canceled, customer_name, wo_esv_data,
    } = await getBatchReportDetail({ wo_id_pk: previewTableData.wo_id_pk });
    if (success) {
      const newKey = previewTableKey + 1;
      this.setState({
        previewTableKey: newKey,
        previewTableData: {
          ...previewTableData, info_list, customer_name, wo_esv_data,
        },
        postApiLoading: false,
      });
    } else if (!canceled) {
      toast.error(message);
      this.setState({ postApiLoading: false });
    }
  }

  /**
   * Make an api call to delete WO, sample, or test
   * @param {*} payload
   * @returns
   */
  handleAfterDeleteConfirm = async (payload) => {
    this.setState({ postApiLoading: true });
    const { user } = this.state;
    let action = "Delete sample";
    if (payload.is_workorder) {
      action = "Delete workorder";
    } else if (payload.analysis) {
      action = "Delete test";
    }
    const user_id = getUser().id;
    const dataDeleted = await deleteWoSampleTest({
      ...payload, frontend_log_data: { action }, user_id, superimpose_delete: user.permissionMap.superimpose_delete_test ? "True" : "False",
    });
    if (!dataDeleted.success) {
      const message = dataDeleted.message ?? "";
      toast.error(message);
      this.setState({ postApiLoading: false });
      return false;
    }
    // sync the workorder state in the main table
    await this.setLatestWoDetail();

    const messageSucess = dataDeleted.message.toLowerCase().includes("success");
    if (messageSucess) {
      toast.success(dataDeleted.message);
    } else {
      toast.error(dataDeleted.message);
    }
    return dataDeleted;
  }

  /**
   * Update the customer name for the workorder in the workorder list
   * @param {*} woList
   * @param {*} data
   * @returns
   */
  updateCustomerName = (woList, data) => {
    const { customerListWithoutID } = this.state;
    const list = woList.map((obj) => ({ ...obj }));
    let previewTableData = {};
    // find the updated customer name based on the data's customer id
    const foundItem = customerListWithoutID.find((customer) => customer.value === data.customer_id);
    list.every(
      (item) => {
        if (item.wo_id === data.workorder_id) {
          item.customer_name = foundItem.label;
          previewTableData = item;
          return false;
        }
        return true;
      },
    );
    return { list, previewTableData };
  }

  /**
   * Make an api call to update the customer for a workorder
   * @param {*} data
   * @returns
   */
  handleEditCustomer = async (data) => {
    this.setState({ postApiLoading: true });
    /** Get the current customer id based on the customer name */
    const payload = {
      workorder_id_list: [data.workorder_id],
      customer_id: data.customer_id,
      original_customer_id: data.original_customer_id,
      frontend_log_data: { action: "Edit customer" },
    };
    const response = await editWoCustomer(payload);
    const message = response.message ?? "Something went wrong";
    if (!response.success) {
      toast.error(message);
      this.setState({ postApiLoading: false });
      return false;
    }

    /** update the edited customer name in the workorder list state */
    await this.setLatestWoDetail();
    toast.success(message);
    return true;
  }

  setClassName = (report) => {
    let className = "";
    if (report.wo_overdue_flag === 1) {
      className = "batchReportWOFlex ";
    }
    return `${className} BatchReport__WorkorderCell__Cursor`;
  };

  /**
   * A method which handles the update test result action
   * @param {*} payload
   * @param {*} test_index
   * @returns
   */
  handleUpdateResultApi = async (payload) => {
    this.setState({ postApiLoading: true });
    const response = await updateTestResult(payload);
    const message = response.message ?? "";
    if (!response.success) {
      toast.error(message);
      this.setState({ postApiLoading: false });
      return null;
    }
    checkReadyReports();
    await this.setLatestWoDetail();
    toast.success(message);
    return response;
  }

  handleWoTypeOnChange = (value) => {
    const {
      selectedDate,
      selectedOption,
      readyResults,
      overDueResults,
      dueByResults,
      resultsDueDate,
    } = this.state;
    this.setState({ view: value }, () => {
      if (overDueResults) {
        this.handleOverDueResults();
      } else if (readyResults) {
        this.handleReadyResults();
      } else if (selectedOption !== "All") { // If a status is selected
        this.handleChangeSelect(
          selectedOption,
          readyResults,
          overDueResults,
          dueByResults,
          resultsDueDate,
        );
      } else { // base call or result due by call
        this.apiBatchReports(selectedDate || resultsDueDate, dueByResults);
      }
    });
  }

  handleRunQC = async (rerun) => {
    const {
      workOrderList,
    } = this.state;
    const workorder_id_list = workOrderList.filter((report) => report.checked === true).map((report) => ({ wo_id: report.wo_id }));

    if (workorder_id_list.length < 1) {
      toast.warning("Please select a work order!");
      return;
    }

    this.abortPrevApiCall();
    this.setState({ postApiLoading: true }, async () => {
      const { success, message } = await runQCApiPost({ rerun, workorder_id_list });
      if (success) {
        toast.success(message);
      } else {
        toast.error(message);
      }
      this.setState({ postApiLoading: false });
    });
  }

  qcPopoverContent = () => {
    const qcItems = [
      // { label: "Run QC", value: false, icon: <PlaySquareOutlined /> },
      { label: "ReRun QC ", value: true, icon: <ReloadOutlined /> },
    ];
    return (
      <div className="BatchReportActionPopoverContent">
        <div className="popover-field">
          <div className="field-options">
            {qcItems.map((option, i) => {
              const { label, value, icon } = option;
              return (
                <Button key={i} className="field-button" type="text" icon={icon} onClick={() => this.handleRunQC(value)}>{label}</Button>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      selectedDate,
      selectedOption,
      dueByResults,
      loading,
      noResults,
      resultsDueDate,
      reportDate,
      receivedDate,
      selectedUpdateStatus,
      workOrderList,
      readyResults,
      overDueResults,
      confirmBatchReports,
      previewTableData,
      previewTableKey,
      statusOptions,
      pendingStatusOptions,
      postApiLoading,
      customerListWithID,
      customerListWithoutID,
      search,
      user,
      loadingPreviewWoId,
      showBlockedModal,
      blockedResults,
      view,
    } = this.state;
    const { authorizedViewOptions } = this.props;
    const currStatusOptions = (readyResults || overDueResults) ? statusOptions.filter((element) => element.value !== "complete") : statusOptions;
    const activeFilterKeys = getActiveBatchReportFilterKeys(this.state);
    const isListFilterActive = (filterKey) => activeFilterKeys.has(filterKey);
    return (
      <>
        <div className="customBatchReports batchReportsSection">
          {authorizedViewOptions.length > 0 && (
          <Segmented
            block
            className="CustomSegmented"
            options={authorizedViewOptions}
            value={view}
            onChange={this.handleWoTypeOnChange}
          />
          )}
          <div className="batchReportsDateSectionButtons">
            <div className="batchReportsDateSection">
              <div className={getBatchReportFilterFieldClassName(isListFilterActive("date"))}>
                <div className="batchReportFilterTitle">Date</div>
                <DatePicker
                  showNow
                  allowClear
                  format="MM/DD/YYYY"
                  value={(selectedDate === "" || selectedDate === "Invalid date") ? "" : dayjs(selectedDate)}
                  defaultValue={(selectedDate === "" || selectedDate === "Invalid date") ? "" : dayjs(selectedDate)}
                  className="batchReportDate"
                  onChange={(e) => this.handleDate(e)}
                  placeholder="mm/dd/yyyy"
                />
              </div>
              <div className={getBatchReportFilterFieldClassName(isListFilterActive("dueBy"))}>
                <div>
                  <div className="batchReportFilterTitle">Results Due By</div>
                  <DatePicker
                    showNow
                    allowClear
                    format="MM/DD/YYYY"
                    value={(resultsDueDate === "" || resultsDueDate === "Invalid date") ? "" : dayjs(resultsDueDate)}
                    defaultValue={(resultsDueDate === "" || resultsDueDate === "Invalid date") ? "" : dayjs(resultsDueDate)}
                    className="batchReportDate"
                    onChange={(e) => this.handleResultsDueDate(e)}
                    placeholder="mm/dd/yyyy"
                  />
                </div>
              </div>
              <button
                type="button"
                onClick={(e) => this.handleOverDueResults(e)}
                className={getBatchReportsModeButtonClassName("batchReportsOverDueBtn", isListFilterActive("overdue"))}
              >
                Over Due Results
              </button>
              <button
                type="button"
                onClick={(e) => this.handleReadyResults(e)}
                className={getBatchReportsModeButtonClassName("batchReportsReadyResultsBtn", isListFilterActive("ready"))}
              >
                Ready Results
              </button>
              <BatchReportsSearch
                updateSearchParameter={this.updateSearchParameter}
                customerList={customerListWithID}
                search={search}
                onSearch={this.handleSearch}
              />
            </div>
            <button
              type="button"
              onClick={(e) => this.handleSubmit(e, false, true)}
              className="batchReportsPartialResultsBtn "
            >
              Partial Results
            </button>
          </div>
          <div className="batchReportsFilterSection">
            <div className="batchReportsFilterButtons">
              <div className={getBatchReportFilterFieldClassName(isListFilterActive("status"))}>
                <div className="batchReportFilterTitle">Status </div>
                <div className="BatchReport__StatusSelectDiv">
                  <Select
                    className="BatchReport__StatusSelect"
                    popupClassName="BatchReport__StatusSelect__Menu"
                    allowClear={false}
                    value={selectedOption}
                    options={currStatusOptions.map((option) => ({
                      value: option.value,
                      label: <span style={{ color: option.color }}>{option.label}</span>,
                    }))}
                    onSelect={(statusValue) => this.handleChangeSelect(
                      statusValue,
                      readyResults,
                      overDueResults,
                      dueByResults,
                      resultsDueDate,
                    )}
                  />
                </div>
              </div>

              <div>
                <div className="batchReportFilterTitle">Report Date</div>
                <DatePicker
                  showNow
                  allowClear
                  format="MM/DD/YYYY"
                  value={(reportDate === "" || reportDate === "Invalid date") ? "" : dayjs(reportDate)}
                  defaultValue={(reportDate === "" || reportDate === "Invalid date") ? "" : dayjs(reportDate)}
                  className="batchReportDate"
                  onChange={(e) => this.handleReportDate(e)}
                  placeholder="mm/dd/yyyy"
                />
              </div>
              <div>
                <div className="batchReportFilterTitle">Received Date</div>
                <DatePicker
                  showNow
                  allowClear
                  format="MM/DD/YYYY"
                  value={(receivedDate === "" || receivedDate === "Invalid date") ? "" : dayjs(receivedDate)}
                  defaultValue={(receivedDate === "" || receivedDate === "Invalid date") ? "" : dayjs(receivedDate)}
                  className="batchReportDate"
                  onChange={(e) => this.handleReceivedDate(e)}
                  placeholder="mm/dd/yyyy"
                />
              </div>
              {readyResults || overDueResults ? (
                ""
              ) : (
                <div className="batchReportsUpdateStatusContainer">
                  <div>
                    <div className="batchReportFilterTitle">Update Status </div>
                    <div>
                      <Select
                        className="BatchReport__StatusSelect"
                        popupClassName="BatchReport__StatusSelect__Menu"
                        allowClear={false}
                        value={selectedUpdateStatus}
                        options={pendingStatusOptions.map((option) => ({
                          value: option.value,
                          label: <span style={{ color: option.color }}>{option.label}</span>,
                        }))}
                        onSelect={(value) => this.handleUpdateStatus(value)}
                      />
                    </div>
                  </div>
                  <div
                    onClick={() => this.handleUpdateStatusSubmit()}
                    className="batchReportsUpdateStatusBtn"
                  >
                    Save
                  </div>
                </div>
              )}
              <div className="batchReportsReRunQCBtnContainer">
                <div
                  onClick={() => this.handleRunQC(true)}
                  className="rerunQcTbn"
                >
                  ReRun QC
                </div>
              </div>
              {/* <div className="BatchReportQcPopverContainer">
                <Popover
                  placement="bottom"
                  overlayClassName="BatchReportActionPopover"
                  arrow={false}
                  content={this.qcPopoverContent()}
                >
                  <Button icon={<MoreOutlined />} className="qcButton" iconPosition="end">QC</Button>
                </Popover>
              </div> */}
            </div>
            <div className="batchReportsFilterCheckboxes">
              {overDueResults
                && (
                  <button
                    type="button"
                    onClick={() => this.exportOverDueResults()}
                    className="batchReportsOverDueBtn"
                  >
                    Export Overdue
                  </button>
                )}
              {readyResults
                && (
                  <button
                    type="button"
                    onClick={() => this.exportReadyResults()}
                    className="batchReportsOverDueBtn"
                  >
                    Export Ready
                  </button>
                )}
              <div
                onClick={(e) => this.handleSelectAll(e)}
                className="batchReportsFilterCheckboxesSelect"
              >
                Select All
              </div>
              <div
                onClick={(e) => this.handleClearAll(e)}
                className="batchReportsFilterCheckboxesSelect"
              >
                Clear All
              </div>
            </div>
          </div>
          <div className="batchReportContainer">
            <div
              className="batchReportData"
            >
              <Scrollbar
                className="BatchReport__WorkorderScrollBar"
                disableTrackYWidthCompensation
                disableTracksWidthCompensation
              >
                <div className={loading ? "batchReportsTable__Skeleton" : "batchReportsTable"} style={{ height: (!Object.keys(previewTableData).length === 0) ? "40vh" : "unset" }}>
                  {!loading && workOrderList.map((report, index) => {
                    const classNames = this.setClassName(report);
                    return (
                      <div key={index} className="batchReportWO" style={{ backgroundColor: (report.wo_id === previewTableData.wo_id) ? "#f4f5f7" : "unset" }}>
                        <input
                          className="batchReportWOCheckbox"
                          onChange={(e) => this.handleChangeCheckbox(e, report.wo_id, workOrderList)}
                          type="checkbox"
                          checked={report.checked}
                        />
                        <div
                          onClick={() => this.handleWorkorderSelect(report)}
                          id={report.wo_id}
                          className={classNames}
                          style={BATCH_REPORT_WO_STATUS[report.status]?.style}
                        >
                          {user.permissionMap.view_hidden_workorder_icon_automation && report.is_deleted === 2 && (<EyeInvisibleOutlined className="BatchReport__HiddenIcon" />)}
                          {report.wo_overdue_flag === 1 ? <ToolTip className="BatchReport__OverdueTooltip" title="At least one test is past its due date." placement="top" component={<i className="fa fa-clock-o batchWOOverDue" />} /> : null}
                          {report.wo_id}
                        </div>
                        {loadingPreviewWoId === report.wo_id && <LoadingOutlined className="BatchReport__LoadingPreviewIcon" />}
                      </div>
                    );
                  })}
                  {loading && [...Array(40)].map((_, index) => (
                    <div key={index} className="batchReportWO">
                      <Skeleton.Input active size="small" />
                    </div>
                  ))}
                </div>
              </Scrollbar>
              {workOrderList.length > 0 && (

                <div className="batchReportsFooter">
                  {readyResults ? (
                    <button
                      type="button"
                      onClick={(e) => this.handleSubmit(e, false, false)}
                      className="batchReportsFooterButton"
                    >
                      Generate Report
                    </button>
                  ) : (
                    <button
                      type="button"
                      onClick={() => this.handleSubmitConfirm()}
                      className="batchReportsFooterButton"
                    >
                      Generate Report
                    </button>
                  )}
                  {/* <button
                // onClick={(e) => this.handleSubmit(e, false, false)}
                onClick={() => this.handleSubmitConfirm()}
                className="batchReportsFooterButton"
              >
                Generate Report
              </button> */}
                  <button
                    type="button"
                    onClick={(e) => this.handleSubmit(e, true, false)}
                    className="batchReportsFooterButtonPartial batchReportsFooterButton"
                  >
                    Generate Partial
                  </button>
                </div>
              )}
            </div>

            {(previewTableData.info_list) && (
              <Spin spinning={loadingPreviewWoId !== null} size="small">
                <div className="batchReportPreview">
                  <BatchReportsPreviewTable
                    previewTableData={previewTableData}
                    key={previewTableKey}
                    handleClosePreview={this.handleClosePreview}
                    handleEditCustomer={this.handleEditCustomer}
                    handlePartialTestSubmit={(wo_id, list) => this.handlePartialTestSubmit(wo_id, list)}
                    handleAfterDeleteConfirm={(payload) => this.handleAfterDeleteConfirm(payload)}
                    handleUpdateResultApi={(payload) => this.handleUpdateResultApi(payload)}
                    customerList={customerListWithoutID}
                  />
                </div>
              </Spin>
            )}

          </div>
          {postApiLoading && (
            <div className="loadingIndicator">
              <img src={Loading} alt="Loading gif" />
            </div>
          )}
          {noResults.length > 0 && (
            <BatchReportsAlert
              noResults={noResults}
              onToggleModal={this.onToggleModal}
            />
          )}
          {showBlockedModal && (
            <BlockedResultsModal
              title="Status update blocked for the following Workorders"
              columns={batchReportsBlockedColumns}
              blockedResults={blockedResults}
              toggleModal={this.toggleBlockedModal}
            />
          )}
        </div>
        <ConfirmationModal
          title="Confirm"
          open={confirmBatchReports}
          bodyText="Are you sure you want to generate reports?"
          okText="Generate"
          cancelText="Cancel"
          onCancel={this.handleCancelConfirm}
          onOk={this.handleSubmit}
          width="auto"
          loading={postApiLoading}
        />
      </>
    );
  }
}
